/**
 * Boot file for setting the confirmation dialogs, error notifications,
 * and success notifications styles globally in the app.
 */

import { i18n } from './i18n.js';
import { Dialog, Notify } from 'quasar';

function notifySuccess(message) {
    return Notify.create({
        message: message,
        color: 'green',
        textColor: 'white',
        position: 'top',
        icon: 'fas fa-check-circle'
    });
}

function notifyError(message, error) {
    // log error
    let consoleMessage = `NotifyError: ${message}`;

    if (error) {
        consoleMessage = `${consoleMessage} : ${JSON.stringify(error)}`;
    }
    console.error(consoleMessage);

    return Notify.create({
        message: message,
        color: 'red',
        textColor: 'white',
        position: 'top',
        icon: 'fas fa-times-circle'
    });
}

function confirmDelete(message) {
    return Dialog.create({
        message: message,
        title: i18n.global.t('Delete permanently?'),
        ok: {
            color: 'negative',
            label: i18n.global.t('Delete'),
            id: 'delete-button'
        },
        cancel: {
            color: 'white',
            textColor: 'black',
            outline: true,
            label: i18n.global.t('Cancel')
        },
        class: 'q-px-sm q-pb-sm'
    });
}

function confirmZeroPackagingFactor(message) {
    return Dialog.create({
        message: message,
        title: i18n.global.t('Zero Packaging Factor'),
        ok: {
            color: 'primary',
            label: i18n.global.t('Confirm')
        },
        cancel: {
            color: 'white',
            textColor: 'black',
            outline: true,
            label: i18n.global.t('Cancel')
        },
        class: 'q-px-sm q-pb-sm'
    });
}

export default ({ app }) => {
    app.config.globalProperties.$notifySuccess = notifySuccess;
    app.config.globalProperties.$notifyError = notifyError;
    app.config.globalProperties.$confirmDelete = confirmDelete;
    app.config.globalProperties.$confirmZeroPackagingFactor =
        confirmZeroPackagingFactor;
};

export { notifySuccess, notifyError };
